<template>
  <div>
    <div id="reportReasonDistributionBarChart" ref="reportReasonDistributionBarChart"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  props: ["data"],
  data() {
    return {
      chart: null,
      noDataLabel: null,
      user: this.$store.getters.currentUser,
      productColors: {
        mpx1: "#8FDCFF",
        mpx2: "#6F71E5",
        mpx3: "#FFB7BD",
        spx1: "#BD9BDB",
        spx2: "#DFA57B",
        other: "#88FFB6",
      },
      dummyData: [
        {
          reason: "Oli Bocor",
          mpx1: this.randomInt(100, 1000),
          mpx2: this.randomInt(100, 1000),
          mpx3: this.randomInt(100, 1000),
          spx1: this.randomInt(100, 1000),
          spx2: this.randomInt(100, 1000),
        },
        {
          reason: "Label Rusak",
          mpx1: this.randomInt(100, 1000),
          mpx2: this.randomInt(100, 1000),
          mpx3: this.randomInt(100, 1000),
          spx1: this.randomInt(100, 1000),
          spx2: this.randomInt(100, 1000),
        },
        {
          reason: "QR Code Tidak Valid",
          mpx1: this.randomInt(100, 1000),
          mpx2: this.randomInt(100, 1000),
          mpx3: this.randomInt(100, 1000),
          spx1: this.randomInt(100, 1000),
          spx2: this.randomInt(100, 1000),
        },
        {
          reason: "Oli Expired",
          mpx1: this.randomInt(100, 1000),
          mpx2: this.randomInt(100, 1000),
          mpx3: this.randomInt(100, 1000),
          spx1: this.randomInt(100, 1000),
          spx2: this.randomInt(100, 1000),
        },
        {
          reason: "Tutup Botol Rusak",
          mpx1: this.randomInt(100, 1000),
          mpx2: this.randomInt(100, 1000),
          mpx3: this.randomInt(100, 1000),
          spx1: this.randomInt(100, 1000),
          spx2: this.randomInt(100, 1000),
        },
      ],
    };
  },
  computed: {
    isOilProduct() {
      return this.user && this.user.product_category_id === 1;
    },
    isMineralProduct() {
      return this.user && this.user.product_category_id === 6;
    },
    isSyntheticProduct() {
      return this.user && this.user.product_category_id === 5;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.createChart();
      this.getData();
    });
  },
  watch: {
    data: {
      deep: true,
      handler: "getData",
      immediate: true,
    },
    isOilProduct() {
      this.recreateChart();
    },
    isMineralProduct() {
      this.recreateChart();
    },
    isSyntheticProduct() {
      this.recreateChart();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },

  methods: {
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    recreateChart() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.$nextTick(() => {
        this.createChart();
        this.getData();
      });
    },
    createChart() {
      this.chart = am4core.create(this.$refs.reportReasonDistributionBarChart, am4charts.XYChart);

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "reason";
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.grid.template.location = 0;

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = false;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.min = 0;

      valueAxis.title.text = "Total";
      valueAxis.title.rotation = 270;
      valueAxis.title.align = "center";
      valueAxis.title.valign = "middle";

      this.noDataLabel = this.chart.tooltipContainer.createChild(am4core.Label);
      this.noDataLabel.html = `<p style="font-weight: bold; font-size: 1.5rem;">No Data</p>`;
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.hide();

      if (this.isMineralProduct) {
        this.createSeries("unknown", "Other", this.productColors.other, true, false);
        this.createSeries("min", "Mineral Gear Oil", this.productColors.mpx1, true, true);
      } else if (this.isSyntheticProduct) {
        this.createSeries("unknown", "Other", this.productColors.other, true, false);
        this.createSeries("syn", "Synthetic Gear Oil", this.productColors.spx1, true, true);
      } else {
        this.createSeries("unknown", "Other", this.productColors.other, true, false);
        this.createSeries("spx2", "SPX2", this.productColors.spx2, true, false);
        this.createSeries("spx1", "SPX1", this.productColors.spx1, true, false);
        this.createSeries("mpx3", "MPX3", this.productColors.mpx3, true, false);
        this.createSeries("mpx2", "MPX2", this.productColors.mpx2, true, false);
        this.createSeries("mpx1", "MPX1", this.productColors.mpx1, true, true);
      }

      this.chart.legend = new am4charts.Legend();
      this.chart.legend.position = "bottom";
      this.chart.legend.fontSize = 12;
      this.chart.legend.marginTop = 20;
      this.chart.legend.reverseOrder = true;
      this.chart.legend.useDefaultMarker = true;
      let markerTemplate = this.chart.legend.markers.template;
      markerTemplate.width = 12;
      markerTemplate.height = 12;

      if (this.chart.tooltip) {
        this.chart.tooltip.background.fill = am4core.color("#FFFFFF");
        this.chart.tooltip.background.stroke = am4core.color("#CCCCCC");
        this.chart.tooltip.background.strokeWidth = 1;
        this.chart.tooltip.background.cornerRadius = 4;
        this.chart.tooltip.getFillFromObject = false;
        this.chart.tooltip.label.fill = am4core.color("#000000");
      }

      let cursor = new am4charts.XYCursor();
      this.chart.cursor = cursor;

      this.setupNoDataLabel();
    },

    setupNoDataLabel() {
      this.chart.events.on("datavalidated", () => {
        let isEmpty = false;

        if (this.isMineralProduct) {
          isEmpty =
            !this.chart.data ||
            this.chart.data.length === 0 ||
            this.chart.data.every((d) => {
              return (!d.min || d.min === 0) && (!d.unknown || d.unknown === 0);
            });
        } else if (this.isSyntheticProduct) {
          isEmpty =
            !this.chart.data ||
            this.chart.data.length === 0 ||
            this.chart.data.every((d) => {
              return (!d.syn || d.syn === 0) && (!d.unknown || d.unknown === 0);
            });
        } else {
          isEmpty =
            !this.chart.data ||
            this.chart.data.length === 0 ||
            this.chart.data.every((d) => {
              return (
                (!d.mpx1 || d.mpx1 === 0) &&
                (!d.mpx2 || d.mpx2 === 0) &&
                (!d.mpx3 || d.mpx3 === 0) &&
                (!d.spx1 || d.spx1 === 0) &&
                (!d.spx2 || d.spx2 === 0) &&
                (!d.unknown || d.unknown === 0)
              );
            });
        }

        if (isEmpty) {
          this.noDataLabel.show();
        } else {
          this.noDataLabel.hide();
        }
      });
    },
    createSeries(field, name, color, stacked, hasRoundedTop = false) {
      let series = new am4charts.ColumnSeries();
      this.chart.series.push(series);
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "reason";
      series.name = name;
      series.stacked = stacked;
      series.columns.template.width = am4core.percent(32);
      series.columns.template.tooltipText = "{name}: {valueY}";
      series.fill = am4core.color(color || "#F2809F");
      series.stroke = am4core.color(color || "#F2809F");

      series.tooltip.background.fill = am4core.color("#FFFFFF");
      series.tooltip.background.stroke = am4core.color("#CCCCCC");
      series.tooltip.background.strokeWidth = 1;
      series.tooltip.background.cornerRadius = 4;
      series.tooltip.getFillFromObject = false;
      series.tooltip.label.fill = am4core.color("#000000");

      series.columns.template.adapter.add("visible", (_visible, target) => {
        return target.dataItem && target.dataItem.valueY > 0;
      });

      if (hasRoundedTop) {
        let columnTemplate = series.columns.template;
        columnTemplate.column.cornerRadiusTopLeft = 8;
        columnTemplate.column.cornerRadiusTopRight = 8;
        columnTemplate.innerRadius = 8;
      }

      return series;
    },
    getData() {
      if (!this.chart) return;

      let incomingData = this.data || [];
      let data = [];

      if (this.isMineralProduct) {
        data = incomingData.map((x) => ({
          reason: x.reason || "Unknown",
          min: x.min || 0,
          unknown: x.unknown || 0,
        }));
      } else if (this.isSyntheticProduct) {
        data = incomingData.map((x) => ({
          reason: x.reason || "Unknown",
          syn: x.syn || 0,
          unknown: x.unknown || 0,
        }));
      } else {
        data = incomingData.map((x) => ({
          reason: x.reason || "Unknown",
          mpx1: x.mpx1 || 0,
          mpx2: x.mpx2 || 0,
          mpx3: x.mpx3 || 0,
          spx1: x.spx1 || 0,
          spx2: x.spx2 || 0,
          unknown: x.unknown || 0,
        }));
      }

      this.chart.data = data || [];
      this.chart.invalidateData();
    },
  },
};
</script>

<style>
#reportReasonDistributionBarChart {
  width: 100%;
  height: 400px;
}
</style>
